import { render, staticRenderFns } from "./EuthanasiaReasonList.vue?vue&type=template&id=b6bc9c62&scoped=true&"
import script from "./EuthanasiaReasonList.vue?vue&type=script&lang=js&"
export * from "./EuthanasiaReasonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bc9c62",
  null
  
)

export default component.exports